import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { configProviderInjectionKey as c } from "../../config-provider/src/context.js";
import d from "../../../../../../lodash-es@4.17.21/node_modules/lodash-es/upperFirst.js";
import { defineComponent as t, inject as m, h as p } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function I(n, l) {
  const u = t({
    render() {
      return l();
    }
  });
  return t({
    name: d(n),
    setup() {
      var e;
      const o = (e = m(c, null)) === null || e === void 0 ? void 0 : e.mergedIconsRef;
      return () => {
        var r;
        const i = (r = o == null ? void 0 : o.value) === null || r === void 0 ? void 0 : r[n];
        return i ? i() : p(u, null);
      };
    }
  });
}
export {
  I as replaceable
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/icons/replaceable.js
// module id = 55
// module chunks = 67